import { ContentstackService } from './contentstack-service';
export class ContentstackSingletonService {
    constructor(contentstackServiceInstance) {
        this.contentstackServiceInstance = contentstackServiceInstance;
    }
    static getInstance(config) {
        if (!ContentstackSingletonService.instance) {
            ContentstackSingletonService.instance = new ContentstackSingletonService(new ContentstackService(config));
        }
        return ContentstackSingletonService.instance;
    }
    getStack() {
        return this.contentstackServiceInstance.getStack();
    }
    getTypedService() {
        return this.contentstackServiceInstance;
    }
    getService() {
        return this.contentstackServiceInstance;
    }
}
//# sourceMappingURL=contentstack-singleton-service.js.map